import * as angular from "angular";
import {IController} from "angular";

export class BringozHelpButtonComponent implements IController {

  unreadCount: number;

  constructor() {
  }

  $onInit() {
    this.initIntercom();
  }

  // ctrl.click = function () {
  //   // BringozHelp.click();
  // };

  private initIntercom() {
    // Intercom('onShow', () => {
    //   this.unreadCount = 0;
    // });
  }
}

angular
  .module('bringoz.admin.commons')
  .component('bringozHelpButton', {
    templateUrl: 'app/modules/commons/components/bringoz-help-button/bringoz-help-button.html',
    controller: BringozHelpButtonComponent
  });
